import { EventType } from '@ag-ui/core'
import {
  DMP_CHAT_USAGE_EVENT_NAME,
  type DmpChatFixtureMode,
  type DmpChatTurn,
  type DmpChatUsage,
} from '../state/dmpChatState.ts'

export const DMP_CHAT_FIXTURE_DELAY_MS = 140
export const DMP_CHAT_CHARACTER_DELAY_MS = 15
type FixtureEvent = Record<string, unknown>

export function createDmpChatFixture(mode: DmpChatFixtureMode, turn: DmpChatTurn): readonly string[] {
  const correlation = {
    threadId: turn.chatId,
    runId: turn.runId,
    requestId: turn.requestId,
  }

  if (mode === 'failure') {
    return [
      stringifyFixtureEvent({
        type: EventType.RUN_STARTED,
        ...correlation,
      }),
      stringifyFixtureEvent({
        type: EventType.TEXT_MESSAGE_START,
        messageId: turn.assistantMessageId,
        role: 'assistant',
        ...correlation,
      }),
      stringifyFixtureEvent({
        type: EventType.TEXT_MESSAGE_CONTENT,
        messageId: turn.assistantMessageId,
        delta: 'The Project Agent started processing the project request.',
        ...correlation,
      }),
      stringifyFixtureEvent({
        type: EventType.TEXT_MESSAGE_END,
        messageId: turn.assistantMessageId,
        ...correlation,
      }),
      stringifyFixtureEvent({
        type: EventType.RUN_ERROR,
        message: 'Fixture worker failure',
        code: 'FIXTURE_FAILURE',
        ...correlation,
      }),
    ]
  }

  const firstTextMessageId = 'worker-message-before-tools'
  const secondTextMessageId = 'worker-message-after-tools'

  return [
    stringifyFixtureEvent({
      type: EventType.RUN_STARTED,
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.STEP_STARTED,
      stepName: 'project-context',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.REASONING_MESSAGE_START,
      messageId: 'reasoning-project-context',
      role: 'reasoning',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.REASONING_MESSAGE_CONTENT,
      messageId: 'reasoning-project-context',
      delta:
        'The Project Agent is checking the project context. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.REASONING_MESSAGE_END,
      messageId: 'reasoning-project-context',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TEXT_MESSAGE_START,
      messageId: firstTextMessageId,
      role: 'assistant',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TEXT_MESSAGE_CONTENT,
      messageId: firstTextMessageId,
      delta:
        'The Project Agent is using the project context.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TOOL_CALL_START,
      toolCallId: 'tool-call-project-context',
      toolCallName: 'read_project_context',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TOOL_CALL_ARGS,
      toolCallId: 'tool-call-project-context',
      delta: '{"projectId":',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TOOL_CALL_ARGS,
      toolCallId: 'tool-call-project-context',
      delta: '42}',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TOOL_CALL_END,
      toolCallId: 'tool-call-project-context',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TOOL_CALL_RESULT,
      messageId: 'tool-result-project-context',
      toolCallId: 'tool-call-project-context',
      content: '{"status":"ok"}',
      role: 'tool',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TEXT_MESSAGE_START,
      messageId: secondTextMessageId,
      role: 'assistant',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TEXT_MESSAGE_CONTENT,
      messageId: secondTextMessageId,
      delta: 'The fixture completed successfully.',
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.TEXT_MESSAGE_END,
      messageId: secondTextMessageId,
      ...correlation,
    }),
    stringifyFixtureEvent({
      type: EventType.RUN_FINISHED,
      outcome: { type: 'success' },
      ...correlation,
    }),
    createDmpChatUsageFixtureEvent(turn, {
      input: 128,
      output: 64,
      reasoning: 32,
      total: 224,
      contextWindow: 16_384,
    }),
  ]
}

export type DmpChatMockScenario =
  | 'success'
  | 'failure'
  | 'tool-active'
  | 'tool-completed'
  | 'tool-failed'
  | 'tool-incomplete'

export const DMP_CHAT_MOCK_SCENARIO_OPTIONS = [
  {
    value: 'success',
    label: 'Success stream',
    description: 'Reasoning, text, tool call, and completed response.',
  },
  {
    value: 'failure',
    label: 'Response failure',
    description: 'Text followed by a failed run.',
  },
  {
    value: 'tool-active',
    label: 'Active tool call',
    description: 'Leaves a tool call running.',
  },
  {
    value: 'tool-completed',
    label: 'Completed tool calls',
    description: 'Completes one tool call and starts another.',
  },
  {
    value: 'tool-failed',
    label: 'Tool failure',
    description: 'Ends a tool call with a failed run.',
  },
  {
    value: 'tool-incomplete',
    label: 'Incomplete tool call',
    description: 'Completes the run without a tool result.',
  },
] as const satisfies readonly {
  value: DmpChatMockScenario
  label: string
  description: string
}[]

export function isDmpChatMockScenario(value: unknown): value is DmpChatMockScenario {
  return DMP_CHAT_MOCK_SCENARIO_OPTIONS.some((option) => option.value === value)
}

export function createDmpChatMockFixture(scenario: DmpChatMockScenario, turn: DmpChatTurn): readonly string[] {
  switch (scenario) {
    case 'success':
      return createDmpChatFixture('success', turn)
    case 'failure':
      return createDmpChatFixture('failure', turn)
    case 'tool-active':
      return createDmpChatToolFixture('active', turn)
    case 'tool-completed':
      return createDmpChatToolFixture('completed', turn)
    case 'tool-failed':
      return createDmpChatToolFixture('failed', turn)
    case 'tool-incomplete':
      return createDmpChatToolFixture('incomplete', turn)
  }
}

export type DmpChatToolFixtureMode = 'active' | 'completed' | 'failed' | 'incomplete' | 'mismatched'

export function createDmpChatToolFixture(mode: DmpChatToolFixtureMode, turn: DmpChatTurn): readonly string[] {
  const correlation = {
    threadId: turn.chatId,
    runId: turn.runId,
    requestId: turn.requestId,
  }
  const runStarted = stringifyFixtureEvent({
    type: EventType.RUN_STARTED,
    ...correlation,
  })
  const toolCallId = `tool-call-${mode}`
  const firstToolParentMessageId = 'worker-message-before-first-tool'
  const toolStart = stringifyFixtureEvent({
    type: EventType.TOOL_CALL_START,
    toolCallId,
    toolCallName: 'read_project_context',
    parentMessageId: firstToolParentMessageId,
    ...correlation,
  })
  const toolArguments = stringifyFixtureEvent({
    type: EventType.TOOL_CALL_ARGS,
    toolCallId,
    delta: '{"projectId":42}',
    ...correlation,
  })

  if (mode === 'active') {
    return [runStarted, toolStart, toolArguments]
  }

  if (mode === 'mismatched') {
    return [
      runStarted,
      stringifyFixtureEvent({
        type: EventType.TOOL_CALL_START,
        toolCallId,
        toolCallName: 'read_project_context',
        ...correlation,
        requestId: `${turn.requestId}-other`,
      }),
      stringifyFixtureEvent({
        type: EventType.TOOL_CALL_RESULT,
        messageId: 'mismatched-tool-result',
        toolCallId,
        content: '{"status":"wrong-turn"}',
        role: 'tool',
        ...correlation,
        requestId: `${turn.requestId}-other`,
      }),
    ]
  }

  const lifecycle = [
    runStarted,
    toolStart,
    toolArguments,
    stringifyFixtureEvent({
      type: EventType.TOOL_CALL_END,
      toolCallId,
      ...correlation,
    }),
  ]

  if (mode === 'completed') {
    const secondToolCallId = `${toolCallId}-second`
    const secondToolParentMessageId = 'worker-message-before-second-tool'
    return [
      ...lifecycle,
      stringifyFixtureEvent({
        type: EventType.TOOL_CALL_RESULT,
        messageId: 'completed-tool-result',
        toolCallId,
        content: '{"status":"ok"}',
        role: 'tool',
        ...correlation,
      }),
      stringifyFixtureEvent({
        type: EventType.TOOL_CALL_START,
        toolCallId: secondToolCallId,
        toolCallName: 'list_project_assets',
        parentMessageId: secondToolParentMessageId,
        ...correlation,
      }),
      stringifyFixtureEvent({
        type: EventType.TOOL_CALL_ARGS,
        toolCallId: secondToolCallId,
        delta: '{"limit":10}',
        ...correlation,
      }),
      stringifyFixtureEvent({
        type: EventType.TOOL_CALL_END,
        toolCallId: secondToolCallId,
        ...correlation,
      }),
      stringifyFixtureEvent({
        type: EventType.TOOL_CALL_RESULT,
        messageId: 'completed-second-tool-result',
        toolCallId: secondToolCallId,
        content: '{"status":"ok","count":2}',
        role: 'tool',
        ...correlation,
      }),
      stringifyFixtureEvent({
        type: EventType.RUN_FINISHED,
        outcome: { type: 'success' },
        ...correlation,
      }),
    ]
  }

  if (mode === 'failed') {
    return [
      ...lifecycle,
      stringifyFixtureEvent({
        type: EventType.RUN_ERROR,
        message: 'Fixture tool failure',
        code: 'FIXTURE_FAILURE',
        ...correlation,
      }),
    ]
  }

  return [
    ...lifecycle,
    stringifyFixtureEvent({
      type: EventType.RUN_FINISHED,
      outcome: { type: 'success' },
      ...correlation,
    }),
  ]
}

export function createDmpChatCancellationEvent(turn: DmpChatTurn): string {
  return stringifyFixtureEvent({
    type: EventType.RUN_ERROR,
    message: 'Fixture cancellation',
    code: 'CANCELLED',
    threadId: turn.chatId,
    runId: turn.runId,
    requestId: turn.requestId,
  })
}

export function createDmpChatUsageFixtureEvent(turn: DmpChatTurn, usage: DmpChatUsage): string {
  return stringifyFixtureEvent({
    type: EventType.CUSTOM,
    name: DMP_CHAT_USAGE_EVENT_NAME,
    value: usage,
    threadId: turn.chatId,
    runId: turn.runId,
    requestId: turn.requestId,
  })
}

function stringifyFixtureEvent(event: FixtureEvent): string {
  return JSON.stringify(event)
}
